export const MAX_DECLINE_REASON_LENGTH = 255;

// Return the trimmed reason when it has 1 to 255 characters. Return null otherwise.
export function normalizeDeclineReason(raw: ?string): ?string {
  const reason = typeof raw === 'string' ? raw.trim() : '';
  if (reason.length < 1 || reason.length > MAX_DECLINE_REASON_LENGTH) {
    return null;
  }
  return reason;
}
